import React from "react";

const FollowUp = () => {
     return (
          <div className="container mt-5">
               This Area is Like a Display Panel where Any Follow Up information will be posted, or if a Account manager wants to ask me to follow up on things. This is not Visible on Client Site
          </div>
     )
}

export default FollowUp;
